import React from 'react';
import { ServiceType } from '../../../types/service.type';
import { getServiceConfig } from '../../../config/serviceConfig';

interface ServiceTypeIconProps {
  type: ServiceType;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showLabel?: boolean;
  className?: string;
}

const ServiceTypeIcon: React.FC<ServiceTypeIconProps> = ({
  type,
  size = 'md',
  showLabel = false,
  className = '',
}) => {
  const config = getServiceConfig(type);

  const sizeClasses = {
    sm: 'w-8 h-8 text-base',
    md: 'w-10 h-10 text-xl',
    lg: 'w-12 h-12 text-2xl',
    xl: 'w-16 h-16 text-3xl',
  };

  const labelSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg',
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div
        className={`
          flex items-center justify-center rounded-lg
          ${config.bgColor} ${config.borderColor} border
          ${sizeClasses[size]}
        `}
      >
        <span>{config.icon}</span>
      </div>
      {showLabel && (
        <span className={`font-medium ${config.color} ${labelSizes[size]}`}>
          {config.label}
        </span>
      )}
    </div>
  );
};

export default ServiceTypeIcon;